import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  padding: 1.375rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const FlexEndButtonWrapper = styled.div`
  justify-content: flex-end;
`;
export const FlexStartButtonWrapper = styled.div`
 
  justify-content: flex-start;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 10px;
`;

export const ContainerLabel = styled.label`
  width: auto;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: #1bace4;
  text-align: center;
  text-align: left;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: ${(props) => props.margin ?? "0"};
  padding: 0;
`;

export const ErrorDiv = styled.div`
  height: 35px;
  border: solid 1px red;
  padding: 7px;
`;
